// UTC 轉台灣 yyyy-MM-dd
export const formatTaiwanDate = (date) => {
    if (!date) return "";
    const utcDate = new Date(date);
    const taiwanTime = new Date(utcDate.getTime() + 8 * 60 * 60 * 1000);
    return taiwanTime.toISOString().slice(0, 10);
}

export const formatTaiwanDateTime = (date) => {
    if (!date) return "";
    
    // 1. 已經是 "YYYY-MM-DD HH:mm:ss" → 轉成 datetime-local 格式
    const normalFormat = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;
    if (normalFormat.test(date)) {
        return date.slice(0, 16).replace(" ", "T");  // 去掉秒數，空格改T
    }

    // 2. 如果是 datetime-local 格式 "2025-11-17T13:00" → 直接返回
    const datetimeLocalFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/;
    if (datetimeLocalFormat.test(date)) {
        return date;
    }

    const dt = new Date(date);

    const year = dt.getUTCFullYear();
    const month = String(dt.getUTCMonth() + 1).padStart(2, "0");
    const day = String(dt.getUTCDate()).padStart(2, "0");

    const hour = String(dt.getUTCHours()).padStart(2, "0");
    const minute = String(dt.getUTCMinutes()).padStart(2, "0");

    return `${year}-${month}-${day}T${hour}:${minute}`;
};

export const formatTaiwanDateTimeAMPM = (date) => {
    if (!date) return "";

    // 1. YYYY-MM-DD HH:mm:ss
    const normalFormat = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/;
    if (normalFormat.test(date)) {
        const [d, t] = date.split(" ");
        let [h, m, s] = t.split(":").map(Number);
        const ampm = h < 12 ? "上午" : "下午";
        return `${d} ${ampm} ${String(h).padStart(2, "0")}:${String(m).padStart(2,"0")}:${String(s).padStart(2,"0")}`;
    }

    // 2. YYYY-MM-DDTHH:mm
    const datetimeLocalFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/;
    if (datetimeLocalFormat.test(date)) {
        const [d, t] = date.split("T");
        let [h, m] = t.split(":");
        const ampm = Number(h) < 12 ? "上午" : "下午";
        return `${d} ${ampm} ${h}:${m}:00`;
    }

    // 3. ISO 格式 YYYY-MM-DDTHH:mm:ss.sssZ 或帶秒
    const isoFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/;
    if (isoFormat.test(date)) {
        const [d, t] = date.split("T");
        let [h, m, s] = t.split(":");
        s = s.includes(".") ? s.split(".")[0] : s; // 去掉毫秒
        const ampm = Number(h) < 12 ? "上午" : "下午";
        return `${d} ${ampm} ${h}:${m}:${s}`;
    }

    return date; // fallback
};



/**
* 將秒數轉換成「X小時 Y分鐘 Z秒」字串
* @param {number} totalSeconds - 總秒數
* @returns {string} - 格式化字串，例如 "1小時 23分鐘 45秒"
*/
export const formatSecondsToHMS = (totalSeconds) => {
    const hrs = Math.floor(totalSeconds / 3600);
    const mins = Math.floor((totalSeconds % 3600) / 60);
    const secs = totalSeconds % 60;

    return `${hrs}小時${mins}分鐘${secs}秒`;
}